export default "__VITE_ASSET__B2qIN$UJ__"